import script from "./IncomeStatementReport.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeStatementReport.vue?vue&type=script&setup=true&lang=js"

import "./IncomeStatementReport.vue?vue&type=style&index=0&id=7abbc895&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7abbc895"]])

export default __exports__